import { ThemeOptions } from '@wix/da-react-context/pkg/constants';

export interface ProfileSkinsSlice {
  activeSkin?: ProfileSkin;
  skinSelectorShown: boolean;
  isSkinSaving: boolean;
}

export interface ProfileSkin {
  skinId: string;
  skinName: string;
  backgroundPreview: string;
  skin?: {
    baseTheme: ThemeOptions;
    background: string;
    staticBackground?: string;
  };
  isCore: boolean;
}

const CACHE_BUSTER = 3;

export const officialSkins: ProfileSkin[] = [
  {
    skinId: 'official',
    skinName: 'Official',
    isCore: false,
    backgroundPreview: 'linear-gradient(225deg, #5d5d6c 0%, #22272b 100%)',
  },
  {
    skinId: 'animal',
    skinName: 'Animal Print',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/animal_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/animal.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'smiley',
    skinName: 'Smiley Faces',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/smiley_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/smiley.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'stars',
    skinName: 'Star Field',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/stars_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/stars.gif?${CACHE_BUSTER})`,
      staticBackground: `url(https://st.deviantart.net/eclipse/profile-skins/stars-static.gif?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'hearts',
    skinName: 'Hearts',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/hearts_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/hearts.gif?${CACHE_BUSTER})`,
      staticBackground: `url(https://st.deviantart.net/eclipse/profile-skins/hearts-static.gif?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'yellowboxes',
    skinName: 'Green Boxes',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/yellow_box_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/yellow_box.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'greenboxes',
    skinName: 'Green Boxes',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/green_box_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/green_box.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'darkrain',
    skinName: 'Dark Rain',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/dark_rain_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/dark_rain.gif?${CACHE_BUSTER})`,
      staticBackground: `url(https://st.deviantart.net/eclipse/profile-skins/dark_rain_static.gif?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'skulls',
    skinName: 'Pretty Skulls',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/skulls_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/skulls.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'healing',
    skinName: 'Healing',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/healing_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/healing.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'greendots',
    skinName: 'Green Dots',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/green_dots_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/green_dots.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'skullspixel',
    skinName: 'Pixel Skulls',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/skulls_pixel_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/skulls_pixel.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'redzebra',
    skinName: 'Red Zebra',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/red_zebra_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/red_zebra.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'purplespots',
    skinName: 'Purple Spots',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/purple_spots_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/purple_spots.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'pixelhearts',
    skinName: 'Green Pixel Hearts',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/pixel_hearts_green_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/pixel_hearts_green.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'pinkandgold',
    skinName: 'Pink & Gold',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/pink_and_gold_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/pink_and_gold.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'orangeflowers',
    skinName: 'Orange Flowers',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/orange_flowers_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/orange_flowers.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'leavesbeige',
    skinName: 'Beige Leaves',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/leaves_beige_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/leaves_beige.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'greenleaves',
    skinName: 'Green Leaves',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/green_leaves_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/green_leaves.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'circlesblue',
    skinName: 'Blue Circles',
    isCore: true,
    backgroundPreview: `url(https://st.deviantart.net/eclipse/profile-skins/circles_blue_preview.png?${CACHE_BUSTER})`,
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: `url(https://st.deviantart.net/eclipse/profile-skins/circles_blue.png?${CACHE_BUSTER})`,
    },
  },
  {
    skinId: 'gradient-tropical',
    skinName: 'Tropical Gradient',
    isCore: true,
    backgroundPreview:
      'linear-gradient(#C6FFDD 0%, #FBD786 51.5%, #F7797D 100%)',
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: 'linear-gradient(#C6FFDD 0%, #FBD786 51.5%, #F7797D 100%)',
    },
  },
  {
    skinId: 'gradient-pinkpurple',
    skinName: 'Pink to Purple Gradient',
    isCore: true,
    backgroundPreview: 'linear-gradient(#EECDA3 0%, #EF629F 97.74%)',
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: 'linear-gradient(#EECDA3 0%, #EF629F 97.74%)',
    },
  },
  {
    skinId: 'gradient-bluepurple',
    skinName: 'Dark Blue to Purple Gradient',
    isCore: true,
    backgroundPreview: 'linear-gradient(#2D1358 0%, #005276 100%)',
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: 'linear-gradient(#2D1358 0%, #005276 100%)',
    },
  },
  {
    skinId: 'gradient-darkblueblack',
    skinName: 'Dark Blue to Grey Gradient',
    isCore: true,
    backgroundPreview: 'linear-gradient(#364C57 0%, #0D1A23 100%)',
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: 'linear-gradient(#364C57 0%, #0D1A23 100%)',
    },
  },
  {
    skinId: 'solid-D0CFDF',
    skinName: 'Solid Color #D0CFDF',
    isCore: true,
    backgroundPreview: '#D0CFDF',
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: '#D0CFDF',
    },
  },
  {
    skinId: 'solid-#E1D7D2',
    skinName: 'Solid Color #E1D7D2',
    isCore: true,
    backgroundPreview: '#E1D7D2',
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: '#E1D7D2',
    },
  },
  {
    skinId: 'solid-#ECF4FF',
    skinName: 'Solid Color #ECF4FF',
    isCore: true,
    backgroundPreview: '#ECF4FF',
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: '#ECF4FF',
    },
  },
  {
    skinId: 'solid-#F8F8ED',
    skinName: 'Solid Color #F8F8ED',
    isCore: true,
    backgroundPreview: '#F8F8ED',
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: '#F8F8ED',
    },
  },
  {
    skinId: 'solid-#FFECE2',
    skinName: 'Solid Color #FFECE2',
    isCore: true,
    backgroundPreview: '#FFECE2',
    skin: {
      baseTheme: ThemeOptions.LIGHT,
      background: '#FFECE2',
    },
  },
  {
    skinId: 'solid-#0D023A',
    skinName: 'Solid Color #0D023A',
    isCore: true,
    backgroundPreview: '#0D023A',
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: '#0D023A',
    },
  },
  {
    skinId: 'solid-#2E2F2E',
    skinName: 'Solid Color #2E2F2E',
    isCore: true,
    backgroundPreview: '#2E2F2E',
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: '#2E2F2E',
    },
  },
  {
    skinId: 'solid-#021C3A',
    skinName: 'Solid Color #021C3A',
    isCore: true,
    backgroundPreview: '#021C3A',
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: '#021C3A',
    },
  },
  {
    skinId: 'solid-#390E32',
    skinName: 'Solid Color #390E32',
    isCore: true,
    backgroundPreview: '#390E32',
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: '#390E32',
    },
  },
  {
    skinId: 'solid-#23383B',
    skinName: 'Solid Color #23383B',
    isCore: true,
    backgroundPreview: '#23383B',
    skin: {
      baseTheme: ThemeOptions.DARK,
      background: '#23383B',
    },
  },
];
